@let paywallInformation = paywallInformation$ | async;

<ion-header id="header">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="close()">Close<ion-icon slot="start" name="close-circle-outline"></ion-icon></ion-button>
    </ion-buttons>
    <ion-title>{{ paywallInformation?.name }}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content color="light">
  <ion-card>
    <div class="tw:relative tw:mt-2 tw:h-20">
      <img alt="Premium Subscription" class="tw:object-contain" ngSrc="/assets/img/primary-subscription.png" fill />
    </div>
    <ion-card-header>
      <ion-card-title class="tw:text-center">{{ paywallInformation?.name }}</ion-card-title>
    </ion-card-header>

    <ion-card-content
      class="smd-sub-description"
      [innerHTML]="paywallInformation?.description | redSanitizeHtml"
    ></ion-card-content>
  </ion-card>
  <ion-button class="tw:m-4" expand="block" (click)="purchase(paywallInformation)">
    {{ paywallInformation?.type === stripePurchaseEnum.Subscription ? 'Subscribe' : 'Purchase' }} <br />
    {{ paywallInformation?.priceText }}
  </ion-button>
  <ion-button class="tw:m-4" expand="block" (click)="close()" fill="outline">
    @if (!onboardingPaywall) {
      Take me back<ion-icon slot="start" name="arrow-back-circle-outline"></ion-icon>
    } @else {
      Take me to the App<ion-icon slot="end" name="arrow-forward-circle-outline"></ion-icon>
    }
  </ion-button>
</ion-content>
